export const formatError = (error, shouldShowInModal, requestName) => {
  const { response } = error || {}
  let formattedError = {}
  if (shouldShowInModal) {
    formattedError.shouldShowInModal = shouldShowInModal
  }
  if (!response && error?.message) {
    const { name, message, statusCode, internalMessage, status } = error || {}
    Object.assign(formattedError, {
      status: statusCode ?? status ?? 500,
      message: message,
      name: name,
      requestName,
      ...(internalMessage && { internalMessage }),
    })
    return formattedError
  }
  formattedError = { ...formattedError, ...response }
  return formattedError
}
